var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagList"},_vm._l((_vm.tagList),function(i){return _c('el-tag',{key:i,staticClass:"tagList-tag",attrs:{"size":"small","type":_vm.tagType},domProps:{"innerHTML":_vm._s(_vm.esHL(i.name))},on:{"click":function($event){return _vm.handlerClick(i)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }